export const apiConfig = {
  axiosApiBaseUrl: import.meta.env.VITE_AXIOS_API_BASE_URL,
  websocketApiUrl: window.env?.WS_API ?? import.meta.env.VITE_WS_API,
  axiosDiscoveryBaseUrl: import.meta.env.VITE_AXIOS_DISCOVERY_API_BASE_URL,
  websocketDiscoveryUrl: window.env?.WS_DISCOVERY_API ?? import.meta.env.VITE_WS_DISCOVERY,
  axiosAiAssistantBaseUrl: import.meta.env.VITE_AXIOS_AI_ASSISTANT_API_BASE_URL,
  axiosAiVisibilityBaseUrl: import.meta.env.VITE_AXIOS_AI_VISIBILITY_API_BASE_URL,
  axiosMonitoringBaseUrl: import.meta.env.VITE_AXIOS_MONITORING_API_BASE_URL,
  axiosSubscriptionApiBaseUrl: import.meta.env.VITE_AXIOS_SUBSCRIPTION_API_BASE_URL,
  envMode: import.meta.env.MODE,
};
